import { createQueryString, decodeQueryString } from '@onpace/api_service/rest_service'

document.addEventSelectorListener('.onspace-link-viewer[download]', 'click', (event) => {
  if (event.metaKey || event.ctrlKey) { return }

  event.preventDefault()

  let url = event.selectedTarget.href
  let urlQueryParams = {}
  if (url.includes('?')) {
    const queryString = url.split('?')[1]
    url = url.replace(/\?.*$/, '')
    urlQueryParams = decodeQueryString(queryString)
  }

  urlQueryParams.disposition = 'attachment'

  const queryString = createQueryString(urlQueryParams)
  url = `${url}?${queryString}`

  window.location.href = url
})
